import { Link } from "react-router-dom";
import { Star, ArrowRight, Check } from "lucide-react";
import { Button, Badge } from "@/components/kit";
import Logo from "@/components/Logo";
import Seo from "@/components/Seo";
import SiteFooter from "@/components/SiteFooter";

const TESTIMONIALS = [
  {
    name: "Rizky Aditya",
    role: "Freelance Digital Marketer",
    text: "Dulu spend 3 jam sehari cari leads manual. Sekarang 5 menit udah dapet ratusan data dari Google Maps. Conversion naik 3x sejak pakai RESADA.",
    rating: 5,
  },
  {
    name: "Sari Dewi",
    role: "Agency Owner, Jakarta",
    text: "Client saya butuh database leads property di Surabaya. RESADA solve dalam hitungan menit. WA blast-nya juga aman, belum pernah kena blokir.",
    rating: 5,
  },
  {
    name: "Budi Santoso",
    role: "UMKM, Yogyakarta",
    text: "Sebagai UMKM kecil, harga RESADA sangat terjangkau. Paket Free udah cukup buat coba, terus upgrade ke Starter karena hasilnya real.",
    rating: 5,
  },
  {
    name: "Maya Putri",
    role: "Sales Manager, Bandung",
    text: "Tim sales kami dari 5 orang jadi lebih efektif. Lead scoring otomatisnya ngefek banget — fokus ke leads yang benar-benar potensial.",
    rating: 5,
  },
  {
    name: "Andi Prasetyo",
    role: "Founder, Solo",
    text: "Saya coba banyak tools sebelum RESADA. Yang ini paling cocok untuk pasar Indonesia — data Google Maps-nya lengkap dan harganya masuk akal.",
    rating: 5,
  },
  {
    name: "Dewi Lestari",
    role: "Konsultan Bisnis, Semarang",
    text: "Saya rekomendasikan RESADA ke semua client saya. Scalable dari UMKM sampai enterprise. Integrasi WhatsApp-nya game changer.",
    rating: 5,
  },
];

export default function TestimonialPage() {
  return (
    <div className="bg-white text-slate-900 min-h-screen">
      <Seo
        title="Testimoni RESADA — Apa Kata Pengguna Kami"
        description="Ribuan freelancer, agency, dan UMKM di Indonesia mempercayai RESADA untuk lead generation dan sales automation mereka."
        path="/testimoni"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "RESADA",
          url: "https://resada.id",
          aggregateRating: { "@type": "AggregateRating", ratingValue: "5", reviewCount: TESTIMONIALS.length },
        }}
      />
      <header className="sticky top-0 z-50 glass border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Logo to="/" iconSize={32} />
          <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-slate-600">
            <Link to="/" className="hover:text-sky-600">Beranda</Link>
            <Link to="/#fitur" className="hover:text-sky-600">Fitur</Link>
            <Link to="/pricing" className="hover:text-sky-600">Harga</Link>
            <Link to="/testimoni" className="text-sky-600">Testimoni</Link>
            <Link to="/blog" className="hover:text-sky-600">Blog</Link>
          </nav>
          <div className="hidden md:flex items-center gap-2">
            <Link to="/login"><Button variant="ghost" size="sm">Masuk</Button></Link>
            <Link to="/register"><Button size="sm">Daftar Gratis</Button></Link>
          </div>
        </div>
      </header>

      <section className="max-w-5xl mx-auto px-6 pt-16 pb-8 text-center">
        <Badge color="sky" className="mb-4">Testimoni</Badge>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold">
          Apa Kata <span className="text-sky-500">Pengguna</span> Kami
        </h1>
        <p className="text-slate-600 mt-4 max-w-2xl mx-auto text-lg">
          Freelancer, agency, dan UMKM di seluruh Indonesia mempercayai RESADA untuk pertumbuhan bisnis mereka.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div key={t.name} className="card-soft p-7 hover:-translate-y-1 transition-transform">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 text-amber-400" fill="currentColor" />
                ))}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 mt-5 pt-5 border-t border-slate-100">
                <div className="w-10 h-10 rounded-full bg-sky-100 text-sky-700 font-bold text-sm grid place-items-center">
                  {t.name.split(" ").map(w => w[0]).join("").slice(0, 2)}
                </div>
                <div>
                  <p className="font-semibold text-sm text-slate-800">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Stats */}
      <section className="bg-slate-900 text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-20" />
        <div className="max-w-4xl mx-auto px-6 relative text-center">
          <h2 className="font-display text-3xl font-extrabold mb-12">Dipercaya Ribuan Bisnis</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { n: "200+", l: "Pengguna aktif" },
              { n: "25.000+", l: "Leads terkumpul" },
              { n: "8.000+", l: "Pesan terkirim" },
              { n: "5/5", l: "Rating pengguna" },
            ].map(s => (
              <div key={s.l}>
                <p className="font-display text-3xl font-extrabold text-sky-400">{s.n}</p>
                <p className="text-sm text-slate-400 mt-1">{s.l}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto px-6 py-20 text-center">
        <h2 className="font-display text-3xl font-extrabold">Siap bergabung?</h2>
        <p className="text-slate-600 mt-3">Mulai dengan 50 lead gratis — tanpa kartu kredit.</p>
        <Link to="/register" className="inline-block mt-6">
          <Button size="lg">Daftar Gratis Sekarang <ArrowRight className="w-4 h-4" /></Button>
        </Link>
      </section>

      <SiteFooter />
    </div>
  );
}
